import { useQuery } from '@tanstack/react-query';
import { useApi } from '../../_shared/hooks';
import { launcherCampaignQueryKey } from '../../_shared/launcher-campaign-schema';
import { fetchCampaign } from '../api-client';
import type { Campaign } from '../components/types';

export function useLauncherCampaign(id: string) {
  const { apiFetch } = useApi();

  const query = useQuery<Campaign>({
    queryKey: launcherCampaignQueryKey(id),
    queryFn: () => fetchCampaign(apiFetch, id),
    enabled: !!id,
  });

  return {
    campaign: query.data ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  } as const;
}
